// ##### 23-09-26 Komarov
import parse from 'html-react-parser';
// ##### 25-04-30 Komarov
import React, { useEffect, useState } from 'react';
// ##### 24-04-23 Komarov
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-14
const OfflineSummary = ({ wait }) => {
  const [hidden, setHidden] = useState('Hidden');
  // ##### Komarov 2025-08-05
  const OfflineBookingFormMessage = useSelector(state => state.pagesRedux[state.language]?.OfflineBookingFormMessage || '');

  // ##### Komarov 2025-07-12
  useEffect(() => {
    setTimeout(Show, wait);
    // ##### 23-04-12 Komarov
  }, [wait]);

  const Show = () => {
    setHidden('');
  };

  return (
    <h2 className={hidden} data-component="OfflineSummary">
      {
        // ##### 23-10-04 Komarov
        parse(OfflineBookingFormMessage)
      }
    </h2>
  );
};

export default OfflineSummary;
